var symphony = symphony || {};

;
(function () {

    symphony.expandingTextCount = 0;
    symphony.expandingText = function () {
        if (symphony.expandingTextCount < 5) {

            $('.u-expandingText:not(.collapsed)').each(function (index, element) {
                if ($(element).outerHeight() > 150) {
                    $(element).addClass('collapsed');
                }
            });

            if (symphony.expandingTextCount == 0) {
                $(document).on('click', '.u-expandingText.collapsed', function (e) {
                    $(this).addClass('expanded');
                });
            }

            setTimeout(function () {
                symphony.expandingTextCount++;
                symphony.expandingText();
            }, 1000);
        }
    };


})();
